import React, { Component } from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import Paper from '@material-ui/core/Paper';
import Edit from './edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Dropdown, Card, Input, Grid, Button, Icon, Pagination } from 'semantic-ui-react';
import Add from './add';
import ReadCookie from '../../functions/readcookies';
import Permission from '../../functions/permission';

class Editbranch extends Component {

  state = {
    load: false,
    editDialog: false,
    allbranch: [],
    data: [],
    branchOptions: [],
    isLoading: false,
    search: '',
    addDialog: false,
    brandOption: [],
    viewEdit: '',
    pageNumber: 0,
    totalPages: 50,
    boundaryRange: 1,
    sortValue: 'DESC',
    siblingRange: 1,
    showEllipsis: true,
    showFirstAndLastNav: true,
    showPreviousAndNextNav: true, totalstockvalue: 0,
    orderby: 'partno', menuPermission: []
  }

  componentDidMount() {
    this.checkBranch();
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('stock-level', this.props.menus);
    this.setState({ menuPermission })
  }

  checkBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      this.setState({ selectedBranch: branchId })
      this.getBranchAllDetails(branchId, 1, this.state.sortValue, this.state.orderby, this.state.search);
    }
  }

  getBrands(data) {
    this.setState({ brandOption: data })
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getBranchAllDetails(this.state.selectedBranch, activePage, this.state.sortValue, this.state.orderby, this.state.search);
  }

  getBranchAllDetails(name, page, sort, orderby, search) {
    let fromSerialNumber = (page * 100) - 100;
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Branch Details',
      addDialog: false
    })
    let data1 = { 'name': name, 'userId': userId, 'page': page, 'sort': sort, 'orderby': orderby, 'search': search }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'branchdetails/getbranchdata.php',
      success: function(data) {
        console.log(data);
        let totalPages = 0;
        let totalStockValue = 0;
        let stocks = [];
        try {
          
          data = JSON.parse(data);
          data.map((c) => { totalStockValue = c.totalstockvalue; stocks = c.data; })
          for (var i = 0; i < stocks.length; i++) {
            let s = 1;
            stocks[i].sino = s + i;
            totalPages = stocks[i].totalPages;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          context.setState({ load: false, data: stocks,
            totalPages: roundOff, pageNumber: page, totalstockvalue: context.convertIntoNumber(totalStockValue),
            fromSerialNumber: fromSerialNumber,
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  edit(id, name, minStock, rackNo, partno, spare_name, brand_id) {
    if (!this.state.menuPermission.edit) {
      alert('You Are Nit Allow To Edit!!!');
      return;
    }
    this.setState({
      name: name,
      minStock: minStock,
      id: id,
      rackNo: rackNo,
      editDialog: true,
      partno: partno,
      spare_name: spare_name,
      brand_id: brand_id
    })
  }

  updateData(data) {
    this.setState({
      data: data,
      editDialog: false
    })
  }

  handleClose = () => {
   this.setState({ editDialog: false, deleteDialog: false, addDialog: false });
  };

  changes = (type) => (f, { value }) => {
    this.setState({ [type]: value });
  }

  search() {
    let context = this;
    let selectedBranch = this.state.selectedBranch;
    let searchData = this.state.search;
    context.setState({
      load: true,
      message: 'Getting Branch Details',
    })
    let data1 = { 'selectedBranch': selectedBranch, 'search': searchData, 'page': 1, 'sort': this.state.sortValue, 'orderby': this.state.orderby }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'branchdetails/getsearchspare.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setState({ data: data, searchclose: true })
        } catch (e) {
          alert(e)
          alert('Error!!!');
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  updateDatas1(val) {
    this.getBranchAllDetails(this.state.selectedBranch, 1, this.state.sortValue, this.state.orderby, this.state.search);
  }

  export() {
    if (!this.state.menuPermission.exports) {
      alert('You Are ot Allow To Export!!!');
      return;
    }
    let branch = this.state.selectedBranch;
    let sortingOrder = this.state.sortValue;
    let orderElement = this.state.orderby;
    let searchData = this.state.search;
    window.location = Server() + 'branchdetails/export.php?branch='+branch+'&sortingOrder='+sortingOrder+'&orderElement='+orderElement+'&searchData='+searchData;
  }

  deleteSearch() {
    this.setState({ searchclose: false, search: '' });
    this.getBranchAllDetails(this.state.selectedBranch, 1, 'DESC', 'partno', '');
  }

  sort(value) {
    this.getBranchAllDetails(this.state.selectedBranch, 1, this.state.sortValue, value, this.state.search);
    if (this.state.sortValue == 'DESC') {
      this.setState({
        sortValue: 'ASC'
      })
    }
    else {
      this.setState({
        sortValue: 'DESC'
      })
    }
  }

  importData = (e) => {
    let context = this;
    let file = e.target.files[0];
    if (!file) {
      return;
    }
    context.setState({ load: true, message: 'File Uploading!!!' });
    var formData = new FormData();
    formData.append('file', file);
    $.ajax({
      type: 'POST', processData: false, contentType: false,
      data: formData, url: Server() + 'branchdetails/import.php',
      success: function(data) {
        context.setState({ load: false });
        if (data == 1) {
          alert('Success');
        } else {
          alert('Failed');
        }
      },
      error: function(error) {
        context.setState({ load: false, });
      }
    });
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }


  render() {
    const { fullScreen } = this.props;
    let i = this.state.fromSerialNumber;
    const { isLoading, value, results } = this.state;
    let totalStocks = 0;
    let total = 0;
    let { load, message, data, editDialog, addDialog, branchOptions, selectedBranch } = this.state;
    return (
      <div>
        <Title title={'Stock Level'} openDrawer={this.props.openDrawer} menus={this.props.menus} />

        { this.state.menuPermission.view ?
          (
            <div>
              <center style={{color: 'red'}}><b>{this.state.permissionError}</b></center>
              <div style={{padding: '0.5%', display: this.state.editmenuview}}>
                <Loading load={load} message={message} />
                <div style={{display: 'flex'}}>
                  <div style={{paddingTop: '0.5%', paddingBottom: '0.5%'}}>
                    <Input placeholder="search...." value={this.state.search} onChange={this.changes('search')}/>
                  </div>
                  <div style={{padding: '0.5%'}}>
                    <Button onClick={this.search.bind(this)}>Search</Button>
                  </div>
                  <div style={{padding: '0.5%'}}>
                    <Button fluid primary onClick={this.export.bind(this)}
                      style={{display: this.state.editmenuexport}} icon labelPosition='left'>
                    Export
                    </Button>
                  </div>
                  <div style={{padding: '0.5%'}}>
                    <Button fluid primary onClick={ () => { 
                        if (!this.state.menuPermission.add) {
                          alert('You Are Nit Allow To Add!!!');
                          return;
                        }
                        this.setState({ addDialog: true }) 
                      }}
                      style={{display: this.state.editmenuedit}} icon labelPosition='left'>
                    Add New
                    </Button>
                  </div>
                  <div style={{width: '60%', textAlign: 'right', fontSize: '18px', color: 'blue'}}>
                    <br/>
                    {'Stock Value : '+this.makeDecimalPoint(this.state.totalstockvalue)}
                  </div>
                </div>
                
                <div>
                  <input onChange={this.importData} style={{display: 'none'}} accept=".csv" id="outlined-button-file" type="file" />
                  <table width="100%" id='table'>
                    <tr id='tablehead'>
                      <th>S.No</th>
                      <th onClick={this.sort.bind(this, 'partno')} id='pointer'>Partno</th>
                      <th onClick={this.sort.bind(this, 'spare_name')} id='pointer'>Spare Name</th>
                      <th onClick={this.sort.bind(this, 'brand')} id='pointer'>Brand</th>
                      <th onClick={this.sort.bind(this, 'stock')} id='pointer'>Stock</th>
                      <th id='pointer'>DNP</th>
                      <th onClick={this.sort.bind(this, 'min_stock')} id='pointer'>Min Stock</th>
                      <th onClick={this.sort.bind(this, 'rackno')} id='pointer'>Rack No</th>
                      
                      <th style={{display: this.state.editmenuedit }}>Edit</th>
                    </tr>
                    { data.map((row) => {
                    
                    i++;
                    let dnp = this.convertIntoNumber(row.dnp);
                    let stock = this.convertIntoNumber(row.stock);
                    total = total + (dnp * stock);
                    totalStocks = totalStocks + stock;
                    return (
                      <tr id='rowselect'>
                        <td><center>{i}</center></td>
                        <td>{row.partno}</td>
                        <td>{row.spare_name}</td>
                        <td>{row.brand}</td>
                        <td>{row.stock}</td>
                        <td><div style={{textAlign: 'right'}}>{this.makeDecimalPoint(dnp * stock)}</div></td>
                        <td><center>{row.min_stock}</center></td>
                        <td>{row.rackno}</td>
                        
                        <td onClick={this.edit.bind(this, row.id, row.name, row.min_stock,
                        row.rackno, row.partno, row.spare_name, row.brand_id)}
                        style={{color: 'blue', cursor: 'pointer', fontSize: 14,
                        width: '5%', display: this.state.editmenuedit}}>
                        <center>Edit</center>
                        </td>
                      </tr>
                    );
                    })
                    }
                  </table>
                </div>
                <div align="right">
                  <Pagination
                    activePage={this.state.pageNumber}
                    boundaryRange={this.state.boundaryRange}
                    onPageChange={this.handlePaginationChange}
                    siblingRange={this.state.siblingRange}
                    totalPages={this.state.totalPages}
                    ellipsisItem={this.state.showEllipsis ? undefined : null}
                    prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                    nextItem={this.state.showPreviousAndNextNav ? undefined : null}
                  />
                </div>

                <Dialog fullScreen={fullScreen} open={editDialog}
                onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
                  <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
                  {"Edit Branch"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Edit name ={this.state.name} min_stock={this.state.minStock}
                      updateData={this.updateData.bind(this)} data={this.state.data}
                      handleClose={this.handleClose} id={this.state.id}
                      rackno={this.state.rackNo} partno={this.state.partno}
                      spare_name={this.state.spare_name} brand_id={this.state.brand_id}
                      brandOption={this.state.brandOption}  />
                    </DialogContentText>
                  </DialogContent>
                </Dialog>

                <Dialog fullScreen={fullScreen} open={addDialog}
                onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
                  <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
                  {"Add Branch"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Add updateDatas1={this.updateDatas1.bind(this)} getBrands={this.getBrands.bind(this)}
                      handleClose={this.handleClose} branchName={this.state.selectedBranch} />
                    </DialogContentText>
                  </DialogContent>
                </Dialog>
              </div>
            </div>

          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Editbranch;
